import React, { useEffect, useState } from "react";
import PrimaryButton from "../common/buttons/PrimaryButton";
import SecondaryButton from "../common/buttons/SecondaryButton";
import axios from "axios";
import { ENDPOINTS } from "../../js/api/_config";
import Header from "../common/header/Header";

import { Toast } from "../common/toast/toast";
import { BackButton } from "../common/back-button/back-button";
import MultiSelectWithCheckbox from "./multiselect-locations";
import { validateRecruiterEmail } from "../../js/api/recruiter";
import { CloseIcon } from "../../assets/icons/close-icon-simple";

const AddRecruierSidebar = ({addToast,closeRecruierSidebar}) => {
    const [clinicInfoId, setClinicInfoId] = useState([]);
    const [selectedClinicId, setSelectedClinicId] = useState("");
    const [selectedClinicName, setSelectedClinicName] = useState("");
    const [addFirstName, setAddFirstName] = useState("");
    const [addLastName, setAddLastName] = useState("");
    const [addRecruiterEmail, setAddRecruiterEmail] = useState("");
    const [errors, setErrors] = useState({});
    const [toasts, setToasts] = useState([]);
    const [apiLoader, setApiLoader] = useState(false)
    const [popup, setPopup] = useState({ show: false, message: "", isError: false });
    const [multiSelectKey, setMultiSelectKey] = useState(0);
    const [recruiterEmailDomainError, setRecruiterEmailDomainError] = useState()

    const fetchData = async () => {
        try {
            const res = await axios.get(ENDPOINTS.CLINIC.CLINIC_INFO,);
            setClinicInfoId(res.data.data || []);
        } catch (error) {

            console.error("Error fetching clinic info:", error);
        }
    };

    const recruiterOptions = clinicInfoId.map((clinic) => ({
        value: clinic.name,
        label: clinic.name,
        id: clinic.clinicalInfoID, // Custom property to store ID
    }))

    // Handle location selection
    const handleSelectChange = (ids) => {
        console.log("Selected Recruiter IDs:", ids.selectedIds);
        const allIDS = ids.selectedIds
        setSelectedClinicId(allIDS);
    };

    // Validate all fields
    const validateFields = () => {
        const newErrors = {};

        if (!addFirstName.trim()) newErrors.addFirstName = "First name is required";
        if (!addLastName.trim()) newErrors.addLastName = "Last name is required";
        if (!addRecruiterEmail.trim()) {
            newErrors.addRecruiterEmail = "Email is required";
        } else if (!/\S+@\S+\.\S+/.test(addRecruiterEmail)) {
            newErrors.addRecruiterEmail = "Invalid email format";
        }
        if (!selectedClinicId) newErrors.selectedClinicId = "Please select Location";

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    // Handle form submission
    const handleAddRecruiter = async (e) => {
        e.preventDefault();

        if (!validateFields()) return;
        setApiLoader(true)
        const addRecruiterResponse = {
            firstName: addFirstName,
            lastName: addLastName,
            recruiterEmail: addRecruiterEmail,
            clinicalInfoIDs: selectedClinicId
        };

        try {
            const response = await axios.post(ENDPOINTS.RECRUITERS.ADD_RECRUITERS, addRecruiterResponse);
            // setPopup({ show: true, message: "The recruiter has been added successfully!", isError: false });

            setAddFirstName("");
            setAddLastName("");
            setAddRecruiterEmail("");
            setSelectedClinicId("");
            setSelectedClinicName("")
            setApiLoader(false)
            setMultiSelectKey(multiSelectKey + 1);
            console.log('recruiterOptions---------', recruiterOptions)

            addToast("Recruiter has been added successfully.", "success");
            closeRecruierSidebar();
        } catch (error) {

            setApiLoader(false)
            console.log('error', error.response.data.message)
            addToast(error.response.data.message || "Failed to add the recruiter.", "error");
            // setPopup({ show: true, message: error.message, isError: true });
        }
    };

    // const addToast = (message, type) => {
    //     const id = Date.now();
    //     setToasts([...toasts, { id, message, type }]);
    //     setTimeout(() => removeToast(id), 3000);
    // };

    // const removeToast = (id) => {
    //     setToasts(toasts.filter((toast) => toast.id !== id));
    // };

    const closePopup = () => {
        setPopup({ show: false, message: "", isError: false });
    };

    useEffect(() => {
        fetchData();
    }, []);

    useEffect(() => {
        if (addRecruiterEmail) {
            validateRecruiterEmail(addRecruiterEmail, setRecruiterEmailDomainError);
        } else {
            setRecruiterEmailDomainError('')
        }
    }, [addRecruiterEmail])

    useEffect(() => {
        console.log('recruiterEmailDomainError', recruiterEmailDomainError)
    }, [recruiterEmailDomainError])

    return (
        <>

            <div className="text-center w-[570px]  bg-white h-full">
                <div className="border-b border-[#B2ACC9] w-full" style={{ borderColor: 'rgb(200, 214, 230)' }}>
                    <div className="flex justify-between items-center w-full px-5 py-6">
                        <h2 className="font-semibold text-left">Add Recruiter</h2>
                        <button onClick={() => {closeRecruierSidebar()}}><CloseIcon /> </button>
                    </div>
                </div>
                <div className="flex flex-col h-[calc(100vh-150px)] py-8">
                    <div className="p-8 pb-0 pt-0 overflow-y-auto h-[calc(100vh-370px)] text-left ">
                        <form onSubmit={handleAddRecruiter}>
                            <div className="w-full grid gap-4">
                                <div>
                                    <label for="firstName" class="block font-semibold title_color pb-4 font-mont">
                                        First Name <span className="aestrick_color">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        id="firstname"
                                        name="firstName"
                                        className="  border_color border text-sm rounded-lg block w-full p-2.5 h-12"
                                        placeholder="Your First Name"
                                        value={addFirstName}
                                        onChange={(e) => setAddFirstName(e.target.value)}
                                    />
                                    {errors.addFirstName && <p className="text-red-500 text-sm">{errors.addFirstName}</p>}
                                </div>
                                <div>
                                    <label for="lastName" class="block form_label_color pb-4">
                                        Last Name <span className="aestrick_color">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        id="lastname"
                                        name="lastName"
                                        className="  border_color border text-sm rounded-lg block w-full p-2.5 h-12"
                                        placeholder="Your Last Name"
                                        value={addLastName}
                                        onChange={(e) => setAddLastName(e.target.value)}
                                    />
                                    {errors.addLastName && <p className="text-red-500 text-sm">{errors.addLastName}</p>}
                                </div>

                                <div>
                                    <label htmlFor="recruiterEmail" className="block form_label_color pb-4">
                                        Email ID <span className="aestrick_color">*</span>
                                    </label>
                                    <input
                                        type="email"
                                        id="email"
                                        className="  border_color border text-sm rounded-lg block w-full p-2.5 h-12"
                                        placeholder="Your Email ID"
                                        value={addRecruiterEmail}
                                        onChange={(e) => setAddRecruiterEmail(e.target.value)}
                                    />
                                    {errors.addRecruiterEmail && <p className="text-red-500 text-sm">{errors.addRecruiterEmail}</p>}
                                    {recruiterEmailDomainError == "Email domain do not match to organization's domain" && <p className="text-red-500 text-sm">{recruiterEmailDomainError}</p>}
                                </div>
                                <div className="relative">
                                    <label
                                        htmlFor="clinic"
                                        className="block form_label_color pb-4"
                                    >
                                        Select Location <span className="aestrick_color">*</span>
                                    </label>
                                    <div className="  border_color border text-sm rounded-lg block w-full p-1 appearance-none" style={{ minHeight: '3rem' }}>
                                        {recruiterOptions && (
                                            <MultiSelectWithCheckbox
                                                options={recruiterOptions}
                                                onChange={handleSelectChange}
                                                key={multiSelectKey}
                                            />)
                                        }

                                    </div>
                                    {errors.selectedClinicId && (
                                        <p className="text-red-500 text-sm">{errors.selectedClinicId}</p>
                                    )}
                                </div>

                            </div>
                            <div className="fixed shadow-[0_-4px_20px_0_rgba(0,0,0,0.25)] p-5 pl-[36px] bottom-0 w-full -ml-8 bg-white pl-8 flex gap-[20px]">
                                <button type="submit" className="px-7 py-1 text-base rounded-md border primary_btn transition-all duration-500" disabled={apiLoader}>{apiLoader ? <div className="flex justify-center"><div className="mini-spinner "></div></div> : "Add"}</button>
                                <SecondaryButton onClick={()=>closeRecruierSidebar()}  label="Cancel" className="text-[#1A1A1B!important] hover:text-[#ffffff!important]" />
                            </div>
                        </form>
                    </div>
                </div>


            </div>
        </>
    );
}

export default AddRecruierSidebar